import React from 'react';
import GiftCardInvoice from '../GiftCardInvoice';
import './InvoiceModal.css';

const InvoiceModal = ({ isOpen, onClose, purchase }) => {
    if (!isOpen) return null;

    return (
        <div className="invoice-modal-overlay">
            <div className="invoice-modal-content">
                <div className="invoice-modal-header">
                    <h2>Gift Card Invoice</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                <div className="invoice-modal-body">
                    <GiftCardInvoice purchase={purchase} />
                </div>
                <div className="invoice-modal-footer">
                    <button className="close-button" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default InvoiceModal; 